import { apiClient } from '@/components/api/apiClient.ts';

const fetcher = (url: string) =>
	apiClient.get(url).then(res => {
		if (res.ok) return res.data;
		else throw res.data;
	});

export default fetcher;
